import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref, shallowRef } from 'vue'
import FileUpload from '@/components/UploadFile/index.vue'
import { UploadFileRes } from '@/api/common/common-api-type'
import { languageOptions } from './type'
import * as DepAPI from '@/api/ocr'
import {
  Message as ElMessage,
  MessageBox,
} from 'element-ui'
import { OCR } from '@/api/ocr/type'

interface IForm {
  language: string,
  fileList: UploadFileRes[]
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OcrText',
  emits: ['set-tab'],
  setup(__props, { emit: emits }) {

const ruleForm = ref()
const form = ref<IForm>(resetForm())
function resetForm () {
  return {
    language: 'cn_common',
    fileList: []
  }
}
const rules = {
  language: [
    { required: true, message: '请选择识别语种', trigger: 'blur' },
  ],
  fileList: [
    { required: true, message: '请上传文件', trigger: 'blur' },
  ]
}

const fileUploadRef = shallowRef<InstanceType<typeof FileUpload>>()
// 存在正在上传的文件
const hasLoading = computed(() => fileUploadRef.value?.hasLoading)
// 存在上传失败的文件
const hasFailUpload = computed(() => fileUploadRef.value?.hasFailUpload)
//点击开始识别
const isLoading = ref(false)
// const emits = defineEmits(['set-tab'])
async function startTask() {
  await ruleForm.value.validate()
  try {
    isLoading.value = true
    await DepAPI.createOCRTaskAPI(
      'pdf',
      form.value.fileList.map(t => t.id),
      form.value.language
    )
    fileUploadRef.value?.clearFiles()
    ElMessage.success('创建成功')
    emits('set-tab', 'listOCR')
  } catch (error) {
    ElMessage.error('创建失败')
  } finally {
    isLoading.value = false
  }
}

return { __sfc: true,ruleForm, form, resetForm, rules, emits, fileUploadRef, hasLoading, hasFailUpload, isLoading, startTask, FileUpload, languageOptions }
}

})